module.exports = __webpack_public_path__ + "static/media/Hero_Story_Mobile.fd041ab1.jpg";